import React, { Component } from 'react';
// import LoadMoreList from './PracticeList';
import LoadMoreList from './containers/AddNumber';
export default class PracticeListRoot extends Component {
    render() {
        return (
            <div> 
                <h1> PracticeList Root</h1>
                <LoadMoreList></LoadMoreList>
            </div>
        )
    }
}
